import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PatientInfo } from '../models/patient.model';

@Injectable({
    providedIn: 'root'
})
export class PatientService {

    constructor(private readonly http: HttpClient) { }

    postFindPatientByCpr$(cpr: string): Observable<PatientInfo> {
        return this.http.post<PatientInfo>(`${environment.backendUrl}/patient/findpatientbycpr`, cpr)
    }
}
